import { Stack } from 'expo-router';
import React from 'react';

function FundingLayout() {
  return <Stack screenOptions={{ headerShown: false }} />;
}

export default FundingLayout;
